import '../../assets/styles/auth.scss'
import '../../assets/styles/pages.scss'
import defaultImage from '../../assets/images/pages/defaultImage.jpg'
import { Link, useLocation, useMatch } from 'react-router-dom'
import DownloadFileModal from '../../components/common/download-file-modal'
import { Fragment, useContext, useEffect, useMemo, useState } from 'react'
import PaginationLayout from '../../components/common/PaginationLayout'
import { GlobalContext, handleError } from '../../context/Provider'
import henceforthApi from '../../utils/henceforthApi'
import Spinner from '../../components/common/spinner'
import moment from 'moment'
import BreadCrumb from '../../components/common/BreadCrumb'
import { numberWithCommas } from '../../utils/validations'
import { orderListType } from './orderInterface'
import OrderStatus from '../../components/order/OrderStatus'
import AllFilter from '../../components/common/AllFilter'

const OrderCancellationList = () => {

    let Limit = 10
    const location = useLocation()
    const match = useMatch('/orders/cancellation/requests/:page')

    const { authState, language_data, loading, setLoading, authDispatch } = useContext(GlobalContext)

    const newParam = new URLSearchParams(location.search);

    const [orderL, setOrderL] = useState<orderListType>({
        total_count: 0,
        data: []
    })

    const breadCrumbPath = [
        { name: `${language_data?.[authState.lang]?.common_home}`, url: `/`, active: '' },
        { name: `${language_data?.[authState.lang]?.common_order} ${language_data?.[authState.lang]?.common_cancellation} ${language_data?.[authState.lang]?.common_list}`, url: ``, active: 'not-allowed' }
    ]

    // ✅ API CALL
    const orderListing = async () => {
        setLoading(true)
        try {
            let res = (await henceforthApi.Order.getOrderList(
                Number(match?.params.page) - 1,
                Limit,
                newParam.toString()
            )).data

            setOrderL({
                total_count: res.total_count,
                data: res.data
            })

        } catch (err: any) {
            setOrderL({ total_count: 0, data: [] })
            handleError(err, 'active', authDispatch)
        } finally {
            setLoading(false)
        }
    }

    // ✅ EXPORT CSV (FIXED KEYS)
    const exportData = async (startDate: number, endDate: number) => {
        try {
            const apiRes = await henceforthApi.Order.export(
                startDate,
                endDate,
                '&order_status=PENDING_CANCELLATION'
            )

            const data = apiRes.data.data

            const rows = [
                ["Sr.", "Order ID", "Customer", "Product ID", "Product", "Delivery Type", "Price", "Status", "Quantity", "Earning"],
            ];

            if (Array.isArray(data)) {
                data.forEach((res: any, index: number) => {
                    const product = res?.products?.[0] || res?.product;
                    rows.push([
                        index + 1,
                        res?.order_id || "",
                        res?.user?.name || "",
                        product?.prodct_id || product?.product_id || "",
                        product?.name || "",
                        res?.delivery_type || "",
                        numberWithCommas(res?.total_price || 0),
                        res?.order_status || "",
                        res?.order_quantity || res?.quantity || 0,
                        numberWithCommas(res?.total_earnings || 0)
                    ])
                })
            }

            const csvContent =
                "data:text/csv;charset=utf-8," +
                rows.map((e) => e.join(",")).join("\n");

            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");

            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `orders_${moment().valueOf()}.csv`);

            document.body.appendChild(link);
            link.click();

        } catch (err: any) {
            handleError(err, 'active', authDispatch)
        }
    }

    useEffect(() => {
        orderListing()
    }, [
        match?.params.page,
        newParam.get("search"),
        newParam.get("product_id"),
        newParam.get("min_price"),
        newParam.get("max_price")
    ])

    return (
        <Fragment>
            <BreadCrumb pathNameDeclare={breadCrumbPath} />

            <div className="w-full px-4 sm:px-6 lg:px-8 py-4 space-y-4">
                {/* 1. Header Card with Title, Counter Badge */}
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 bg-white px-5 py-4 rounded-2xl border border-slate-200/80 shadow-xs">
                    <div>
                        <div className="flex items-center gap-3">
                            <h1 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight m-0">
                                {language_data?.[authState.lang]?.common_order || "Order"}{" "}
                                {language_data?.[authState.lang]?.common_cancellation || "Cancellation"}{" "}
                                {language_data?.[authState.lang]?.common_list || "List"}
                            </h1>
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-rose-50 text-rose-700 border border-rose-200/60 shadow-2xs">
                                {orderL.total_count} {orderL.total_count === 1 ? 'Order' : 'Orders'}
                            </span>
                        </div>
                        <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 mb-0">
                            Track cancelled orders, customer refund statuses, and cancellation reasons.
                        </p>
                    </div>
                </div>

                <AllFilter />

                <div className="bg-white rounded-2xl border border-slate-200/80 shadow-xs overflow-hidden">
                    <div className="p-4 sm:p-5">

                                <div className='data-list-table table-responsive mb-3 text-center'>
                                    {loading ? (
                                        <Spinner color={'text-success'} />
                                    ) : (
                                        <table className="table table-striped align-middle">

                                            <thead>
                                                <tr>
                                                    <th>Sr.</th>
                                                    <th>Order ID</th>
                                                    <th>Customer</th>
                                                    <th>Product ID</th>
                                                    <th>Product Detail</th>
                                                    <th>Delivery Type</th>
                                                    <th>Price</th>
                                                    <th>Status</th>
                                                    <th>Quantity</th>
                                                    <th>Earning</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {orderL.data?.length ? orderL.data.map((res: any, index: number) => {

                                                    // Get first product from products array or fallback to product object
                                                    const product = res?.products?.[0] || res?.product;
                                                    const productImage = product?.images?.[0]
                                                        ? `${henceforthApi.API_FILE_ROOT_SMALL}${product.images[0]}`
                                                        : defaultImage

                                                    const userImage = res?.user?.profile_pic
                                                        ? `${henceforthApi.API_FILE_ROOT_SMALL}${res.user.profile_pic}`
                                                        : defaultImage

                                                    return (
                                                        <tr key={res._id}>

                                                            <td>
                                                                {(Number(match?.params.page) - 1) * Limit + (index + 1)}
                                                            </td>

                                                            <td>{res?.order_id || "N/A"}</td>

                                                            {/* USER */}
                                                            <td className='product-image-table'>
                                                                <img src={userImage} className='rounded-circle me-2' />
                                                                <span>{res?.user?.name || "N/A"}</span>
                                                            </td>

                                                            {/* PRODUCT ID */}
                                                            <td>{product?.prodct_id || product?.product_id || "N/A"}</td>

                                                            {/* PRODUCT DETAIL */}
                                                            <td className='product-image-table d-flex'>
                                                                <img src={productImage} className='me-2' />

                                                                <div>
                                                                    <p>{product?.category_id?.name || product?.category_name || "N/A"}</p>
                                                                    <p>
                                                                        {product?.name?.length > 18
                                                                            ? product.name.slice(0, 18) + "..."
                                                                            : product?.name || "N/A"}
                                                                    </p>
                                                                </div>
                                                            </td>

                                                            {/* DELIVERY TYPE */}
                                                            <td>{res?.delivery_type || "N/A"}</td>

                                                            {/* PRICE */}
                                                            <td>
                                                                $ {numberWithCommas(res?.total_price || 0)}
                                                            </td>

                                                            {/* STATUS */}
                                                            <td>
                                                                <OrderStatus {...res} />
                                                            </td>

                                                            {/* QUANTITY */}
                                                            <td>{res?.order_quantity || res?.quantity || 0}</td>

                                                            {/* EARNING */}
                                                            <td>
                                                                $ {numberWithCommas(res?.total_earnings || 0)}
                                                            </td>

                                                            {/* ACTION */}
                                                            <td>
                                                                <Link
                                                                    className="btn btn-white btn-sm"
                                                                    to={`/order/${res?._id}`}
                                                                >
                                                                    View
                                                                </Link>
                                                            </td>

                                                        </tr>
                                                    )
                                                }) : (
                                                    <tr>
                                                        <td colSpan={11}>No Data Found</td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                    )}
                                </div>

                                <PaginationLayout
                                    data={orderL.data}
                                    count={orderL.total_count}
                                    limit={Limit}
                                    page={Number(match?.params.page)}
                                />

                    </div>
                </div>
            </div>

            <DownloadFileModal exportData={useMemo(() => exportData, [])} />
        </Fragment>
    )
}

export default OrderCancellationList